import {getDefaultState} from '@/store/modules/bs_inf/state'

export const SET_DEMO = 'SET_DEMO'
export const RESET_STATE = 'RESET_STATE'
export const SET_SAVE_ALL = 'SET_SAVE_ALL'
export const SET_SAVE_YEAR = 'SET_SAVE_YEAR'
export const SET_SAVE_NAME = 'SET_SAVE_NAME'

export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_DEMO](state, demo) {
    state.demo = demo
  },
  [SET_SAVE_ALL](state, data) {
    state.information.categoryAll = data
  },
  [SET_SAVE_YEAR](state, data) {
    state.information.categoryYear = data
  },
  [SET_SAVE_NAME](state, data) {
    state.information.categoryName = data
  }
}